import React from "react";
import "./../addNewLinkRegular/AddNewLinkRegular.css";
import "./ModalLinkCreation.css";
import Regular from "./Blocks/Regular";
import YoutubeVideo from "./Blocks/YoutubeVideo";
import YoutubeSub from "./Blocks/YoutubeSub";
import Spotify from "./Blocks/Spotify";
import SoundClound from "./Blocks/SoundCloud";
import BlockTwitch from "./Blocks/Twitch";
import BlockEmail from "./Blocks/Email";
import BandcampAudio from "./Blocks/BandcampAudio";
import Deezer from "./Blocks/Deezer";
import BlockThumbnail from "./Blocks/Thumbnail";
import DividerTitle from "./Blocks/DividerTitle";

const ModalLinkCreation = ({
  setModalOpen,
  isEdittingLink,
  currentLinkType,
  setEdittingLink,
  linkEditDetails,
  currentLinks,
  setRefresh,
  refresh,
  setDisplayBlockPicker,
}) => {
  return (
    <div>
      {currentLinkType === "regular" && (
        <Regular
          setModalOpen={setModalOpen}
          isEdittingLink={isEdittingLink}
          setEdittingLink={setEdittingLink}
          linkEditDetails={linkEditDetails}
          currentLinks={currentLinks}
          setRefresh={setRefresh}
          refresh={refresh}
          setDisplayBlockPicker={setDisplayBlockPicker}
        />
      )}
      {currentLinkType === "youtube-video" && (
        <YoutubeVideo
          setModalOpen={setModalOpen}
          isEdittingLink={isEdittingLink}
          setEdittingLink={setEdittingLink}
          linkEditDetails={linkEditDetails}
          currentLinks={currentLinks}
          setRefresh={setRefresh}
          refresh={refresh}
          setDisplayBlockPicker={setDisplayBlockPicker}
        />
      )}
      {currentLinkType === "youtube-sub" && (
        <YoutubeSub
          setModalOpen={setModalOpen}
          isEdittingLink={isEdittingLink}
          setEdittingLink={setEdittingLink}
          linkEditDetails={linkEditDetails}
          currentLinks={currentLinks}
          setRefresh={setRefresh}
          refresh={refresh}
          setDisplayBlockPicker={setDisplayBlockPicker}
        />
      )}
      {currentLinkType === "spotify" && (
        <Spotify
          setModalOpen={setModalOpen}
          isEdittingLink={isEdittingLink}
          setEdittingLink={setEdittingLink}
          linkEditDetails={linkEditDetails}
          currentLinks={currentLinks}
          setRefresh={setRefresh}
          refresh={refresh}
          setDisplayBlockPicker={setDisplayBlockPicker}
        />
      )}
      {currentLinkType === "soundcloud" && (
        <SoundClound
          setModalOpen={setModalOpen}
          isEdittingLink={isEdittingLink}
          setEdittingLink={setEdittingLink}
          linkEditDetails={linkEditDetails}
          currentLinks={currentLinks}
          setRefresh={setRefresh}
          refresh={refresh}
          setDisplayBlockPicker={setDisplayBlockPicker}
        />
      )}
      {currentLinkType === "twitch-channel" && (
        <BlockTwitch
          setModalOpen={setModalOpen}
          isEdittingLink={isEdittingLink}
          setEdittingLink={setEdittingLink}
          linkEditDetails={linkEditDetails}
          currentLinks={currentLinks}
          setRefresh={setRefresh}
          refresh={refresh}
          setDisplayBlockPicker={setDisplayBlockPicker}
        />
      )}
      {currentLinkType === "email" && (
        <BlockEmail
          setModalOpen={setModalOpen}
          isEdittingLink={isEdittingLink}
          setEdittingLink={setEdittingLink}
          linkEditDetails={linkEditDetails}
          currentLinks={currentLinks}
          setRefresh={setRefresh}
          refresh={refresh}
          setDisplayBlockPicker={setDisplayBlockPicker}
        />
      )}
      {currentLinkType === "bandcamp-audio" && (
        <BandcampAudio
          setModalOpen={setModalOpen}
          isEdittingLink={isEdittingLink}
          setEdittingLink={setEdittingLink}
          linkEditDetails={linkEditDetails}
          currentLinks={currentLinks}
          setRefresh={setRefresh}
          refresh={refresh}
          setDisplayBlockPicker={setDisplayBlockPicker}
        />
      )}
      {currentLinkType === "deezer" && (
        <Deezer
          setModalOpen={setModalOpen}
          isEdittingLink={isEdittingLink}
          setEdittingLink={setEdittingLink}
          linkEditDetails={linkEditDetails}
          currentLinks={currentLinks}
          setRefresh={setRefresh}
          refresh={refresh}
          setDisplayBlockPicker={setDisplayBlockPicker}
        />
      )}
      {currentLinkType.startsWith("thumbnail") && (
        <BlockThumbnail
          setModalOpen={setModalOpen}
          isEdittingLink={isEdittingLink}
          setEdittingLink={setEdittingLink}
          linkEditDetails={linkEditDetails}
          currentLinks={currentLinks}
          setRefresh={setRefresh}
          refresh={refresh}
          setDisplayBlockPicker={setDisplayBlockPicker}
        />
      )}
      {currentLinkType.startsWith("divider-title") && (
        <DividerTitle
          setModalOpen={setModalOpen}
          isEdittingLink={isEdittingLink}
          setEdittingLink={setEdittingLink}
          linkEditDetails={linkEditDetails}
          currentLinks={currentLinks}
          setRefresh={setRefresh}
          refresh={refresh}
          setDisplayBlockPicker={setDisplayBlockPicker}
        />
      )}
    </div>
  );
};

export default ModalLinkCreation;
